import * as React from 'react'
import Breadcrumb from "../components/BreadCurmb"
import AccordionOne from "../components/AccordionOne"
import FooterOne from "../footer/FooterOne"
import HeaderOne from "../header/HeaderOne"
export default function Faq(){
	return(
		<>
		<HeaderOne/>
		<Breadcrumb title="FAQ Page" subtitle="Responsive & functional IT blog" pagetitle="FAQ" />
		<section class="faq-area pt-120 pb-90 pt-md-55 pb-md-30 pt-xs-55 pb-xs-30">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-lg-6 col-md-6">
						<div class="faq-que-list mb-30">
							<AccordionOne/>
						</div>
					</div>
					<div class="col-lg-6 col-md-6">
						<div class="faq-que-list mb-30">
							<AccordionOne/>
						</div>
					</div>
				</div>
			</div>
		</section>
		
		<section class="faq-bg-area pt-120 pb-90 pt-md-55 pb-md-30 pt-xs-55 pb-xs-30"
			>
			<div class="container">
				<div class="row align-items-center justify-content-center">
					<div class="col-lg-12 text-center mb-60">
						<h6 class="fs-14 text-white lh-1 mb-20">FAQ Page</h6>
						<h2 class="sect-title text-white lh-1">Some Q. & Answers</h2>
					</div>
					<div class="col-lg-8 col-md-10">
						<div class="faq-que-list mb-30">
						<AccordionOne/>						
						</div>
					</div>
				</div>
			</div>
		</section>
		<FooterOne/>
		</>

	)
}